<template>
    <div class="index-main">
        <header-bar tab-index="3"/>

        <div class="mes-header">
            <img src="../../resource/img/header.jpg" style="width: 100%;"/>
            <div class="mes-title">行业案例</div>
        </div>

        <div class="index-container">
            <div class="product-detail-body">
                <div class="pd-menu-bar">
                    <div class="pd-menu-main" @click="menu_idx = -1">行业案例</div>
                    <div v-for="(name, index) in menu_list" class="pd-menu-item" :class="menu_idx == index ? 'active' : ''" :data-idx="index" @click="clickMenu(index)">
                        <div class="pd-menu-title" v-text="name"></div>
                        <div class="pd-menu-icon"><i class="fa fa-chevron-right"></i></div>
                    </div>
                    <div class="pd-menu-footer">
                        <img src="../../resource/img/tel.png">
                        <div class="tel-group">
                            <div class="tel-title">全国咨询热线</div>
                            <div class="tel-no">150 4119 0343</div>
                        </div>
                    </div>
                </div>
                <div class="pd-content">
                    <div class="case-group" v-show="page_idx < 0">
                        <div class="case-item" v-show="menu_idx == 4 || menu_idx == -1">
                            <img src="../../resource/img/index/case/1.png"/>
                            <div class="case-item-footer">再生塑料加工-MES系统</div>
                        </div>
                        <div class="case-item" v-show="menu_idx == 1 || menu_idx == -1">
                            <img src="../../resource/img/index/case/2.jpg"/>
                            <div class="case-item-footer">轴承加工-MES系统</div>
                        </div>
                        <div class="case-item" v-show="menu_idx == 2 || menu_idx == -1">
                            <img src="../../resource/img/index/case/5.png"/>
                            <div class="case-item-footer">发泡橡胶加工-MES系统</div>
                        </div>
                        <div class="case-item" v-show="menu_idx == 2 || menu_idx == -1">
                            <img src="../../resource/img/index/case/3.png"/>
                            <div class="case-item-footer">注塑加工-MES系统</div>
                        </div>
                        <div class="case-item" v-show="menu_idx == 0 || menu_idx == -1">
                            <img src="../../resource/img/index/case/4.png"/>
                            <div class="case-item-footer">轧辊加工-MES系统</div>
                        </div>
                    </div>
                    <page1 v-if="page_idx == 0"/>
                    <page2 v-if="page_idx == 1"/>
                    <page3 v-if="page_idx == 2"/>
                    <page4 v-if="page_idx == 3"/>
                    <page5 v-if="page_idx == 4"/>
                </div>
            </div>
        </div>

        <side-bar/>
        <footer-bar/>
    </div>
</template>

<script>
import HeaderBar from '../../components/header';
import FooterBar from '../../components/footer';
import SideBar from '../../components/sider';
import '../../resource/css/common.css';
import '../../resource/css/product-page.css';
import Page1 from '../../components/case/page1';
import Page2 from '../../components/case/page2';
import Page3 from '../../components/case/page3';
import Page4 from '../../components/case/page4';
import Page5 from '../../components/case/page5';

export default {
    name: "productDetail",
    components: {
        'header-bar': HeaderBar,
        'footer-bar': FooterBar,
        'side-bar': SideBar,
        'page1': Page1,
        'page2': Page2,
        'page3': Page3,
        'page4': Page4,
        'page5': Page5,
    },
    data() {
        return {
            menu_idx: -1,
            menu_list: ['机械加工行业', '装备制造行业', '橡胶及塑料行业', '纺织服装行业', '再生资源行业'],
            page_idx: -1,
        }
    },
    mounted() {
        if (this.$route.params.index !== '' && this.$route.params.index !== undefined) {
            this.menu_idx = Number(this.$route.params.index);
        } else {
            this.menu_idx = -1;
        }

        this.$hub.$on('changeMenu', (opt) => {
            if (opt.name === 'case') {
                this.menu_idx = opt.params ? Number(opt.params.index) : -1;
                this.page_idx = -1;
            }
        });

        let that = this;
        $(".case-item").click(function(e) {
            e.stopPropagation();

            that.page_idx = $(this).index();
        });
    },
    methods: {
        clickMenu(idx) {
            this.menu_idx = idx;
            this.page_idx = -1;
        }
    }
}
</script>

<style scoped>
.pd-menu-main {
    cursor: pointer;
}

.case-group {
    display: flex;
    flex-wrap: wrap;
    margin: -20px 0;
}

.case-item {
    width: 20vw;
    height: 20vw;
    margin: 20px;
    box-shadow: 0 0 15px #a4a4a4;
    position: relative;
}

.case-item img {
    width: 100%;
    height: 100%;
}

.case-item-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .6);
    color: #fff;
    font-size: 18px;
    padding: 15px 0;
    text-align: center;
}
</style>
